/** Production DocsAI — OCR/RAG API (port 3020). */
export const DOCS_AI_CONFIG = {
  baseUrl: 'https://api.dms.svayamtech.com:3020/ocr/v1',
  healthUrl: 'https://api.dms.svayamtech.com:3020/ocr/v1/health',
  maxUploadFileSizeMb: 200,
  tenantId: '1',
  userId: 'admin',
} as const;

export function isOcrUrl(url: string): boolean {
  return url.includes('/ocr/v1');
}
